// extracted by mini-css-extract-plugin
export default {"cardsArrows":"card-section--cardsArrows"};